import {types} from './types';

const initialState = {
    users: 0,
    new_users: 0,
    spin: 0,
    detalization_spin: [],
    detalization: {},
    count_online: 0
}

export function informationReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_USERS:
            return { ...state, users: action.payload};
        case types.SET_SPIN:
            return { ...state, spin: action.payload};
        case types.SET_DETALIZATION_SPIN:
            return { ...state, detalization_spin: action.payload};
        case types.SET_DETALIZATION:
            return { ...state, detalization: action.payload};
        case types.SET_NEW_USERS:
            return { ...state, new_users: action.payload};
        case types.SET_COUNT_ONLINE:
            return { ...state, count_online: action.payload};
        default:
            return state
    }
}